import PropTypes from 'prop-types';
import React from 'react';

import { InformationCircleIcon } from '@heroicons/react/solid';
import classNames from 'classnames';
import { useParams } from 'react-router-dom';

import Callout from 'components/Callout/Callout';
import { messageStatus } from 'constants/messageStatus';
import { PAGE_TITLE } from 'constants/meta';
import useUserData from 'contexts/UserContext/hooks/useUserData';
import useTrackIsExpanded from 'routes/Inbox/hooks/useTrackIsExpanded';

import InboxMessageContent from './InboxMessageContent';
import InboxMessageHeader from './InboxMessageHeader/InboxMessageHeader';

const UNAPPROVED_MESSAGE_CALLOUT = `Your message will be reviewed and may be edited by the ${PAGE_TITLE} team to optimise journalist engagement.`;
const APPROVED_MESSAGE_CALLOUT =
  'Your response has been sent and is now with the journalist. We will send you a notification when you get a response.';

const InboxMessage = ({
  message = {},
  thread = {},
  isLast = false,
  isFirst = false,
  showCallout = false,
  threadRef = {},
  journalist = {},
}) => {
  const { messageId } = useParams();
  const { claimsAdmin: isAdmin } = useUserData();

  const isExpanded = messageId === message.uid;

  const isMessageApprovedOrDelivered =
    message.status === messageStatus.DELIVERED ||
    message.status === messageStatus.APPROVED;
  const isMessageApprovedAndScheduled =
    message.status === messageStatus.APPROVED && message.sendAfter;

  const calloutText = isMessageApprovedOrDelivered
    ? APPROVED_MESSAGE_CALLOUT
    : UNAPPROVED_MESSAGE_CALLOUT;

  useTrackIsExpanded({ message, isExpanded, threadRef });

  return (
    <div
      className={classNames('w-full', {
        'bg-gray-50': message.isJournalist,
      })}
    >
      <InboxMessageHeader
        message={message}
        thread={thread}
        threadRef={threadRef}
        journalist={journalist}
        isLast={isLast}
        isFirst={isFirst}
        isExpanded={isExpanded}
        isAdmin={isAdmin}
      />

      <InboxMessageContent
        text={message?.text}
        html={message?.html}
        isExpanded={isExpanded}
        attachments={message?.attachments || []}
      />

      {!(isMessageApprovedAndScheduled && isAdmin) &&
      showCallout &&
      isExpanded ? (
        <Callout
          type="info"
          Icon={InformationCircleIcon}
          wrapperClassName="ml-20 mr-4 mb-4 w-[calc(100%-6rem)]"
        >
          {calloutText}
        </Callout>
      ) : null}
    </div>
  );
};

InboxMessage.propTypes = {
  message: PropTypes.object,
  thread: PropTypes.object,
  threadRef: PropTypes.object,
  isLast: PropTypes.bool,
  isFirst: PropTypes.bool,
  showCallout: PropTypes.bool,
  journalist: PropTypes.object,
};
export default InboxMessage;
